import { useQuery, type UseQueryResult } from 'react-query';
import {
  CharterFilingService,
  type Wealthlane_CapTable_Dtos_CharterFiling_StockClassSnapshotDto,
} from '@wealthlane/api-services/wealthlane-captable-service';

const useGetShareClassSnapshots = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  charterFilingId?: string | null
): UseQueryResult<Wealthlane_CapTable_Dtos_CharterFiling_StockClassSnapshotDto[] | undefined, unknown> => {
  return useQuery(
    ['getShareClassSnapshots', charterFilingId],
    async () => {
      if (charterFilingId) {
        return await handleRequest(
          CharterFilingService.getApiCapTableApiAppCharterFilingShareClassSnapshots(charterFilingId)
        );
      }
    },
    {
      enabled: charterFilingId != null && charterFilingId !== '',
    }
  );
};

export default useGetShareClassSnapshots;
